export const extensions = {
  document: {
    navigation: 'x-scalar-navigation',
    activeAuth: 'x-scalar-active-auth',
  },
  workspace: {
    colorMode: 'x-scalar-color-mode',
    sidebarWidth: 'x-scalar-sidebar-width',
    defaultClient: 'x-scalar-default-client',
    activeDocument: 'x-scalar-active-document',
    theme: 'x-scalar-theme',
  },
} as const
